/* tslint:disable */
/* eslint-disable */
/**
 * SupportService
 * Operation workflow management system
 *
 * The version of the OpenAPI document: v1
 * Contact: info@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { StartNewSessionResponse } from '../model';
// @ts-ignore
import { UserSessionsResponse } from '../model';
/**
 * SessionWorkflowApiApiSessionWorkflowGetUserSessionsGet - axios parameter creator
 * 
 * @param {string} xPlayerID 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SessionWorkflowApiApiSessionWorkflowGetUserSessionsGetAxiosParamCreator (xPlayerID: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'xPlayerID' is not null or undefined
    assertParamExists('apiSessionWorkflowGetUserSessionsGet', 'xPlayerID', xPlayerID)
    const localVarPath = `/api/SessionWorkflow/GetUserSessions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SessionWorkflowApiApiSessionWorkflowStartNewSessionPost - axios parameter creator
 * 
 * @param {string} [xPlayerID] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SessionWorkflowApiApiSessionWorkflowStartNewSessionPostAxiosParamCreator (xPlayerID?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SessionWorkflow/StartNewSession`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiSessionWorkflowGetUserSessionsGet operation in SessionWorkflowApi.
 * @export
 * @interface SessionWorkflowApiApiSessionWorkflowGetUserSessionsGetRequest
 */
export interface SessionWorkflowApiApiSessionWorkflowGetUserSessionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionWorkflowApiApiSessionWorkflowGetUserSessionsGet
     */
    readonly xPlayerID: string
}

/**
 * Request parameters for apiSessionWorkflowStartNewSessionPost operation in SessionWorkflowApi.
 * @export
 * @interface SessionWorkflowApiApiSessionWorkflowStartNewSessionPostRequest
 */
export interface SessionWorkflowApiApiSessionWorkflowStartNewSessionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionWorkflowApiApiSessionWorkflowStartNewSessionPost
     */
    readonly xPlayerID?: string
}

/**
* 
* @param {SessionWorkflowApiApiSessionWorkflowGetUserSessionsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SessionWorkflowApiApiSessionWorkflowGetUserSessionsGet(requestParameters: SessionWorkflowApiApiSessionWorkflowGetUserSessionsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SessionWorkflowApiApiSessionWorkflowGetUserSessionsGetAxiosParamCreator(requestParameters.xPlayerID, options, configuration);
    const request: () => AxiosPromise<UserSessionsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SessionWorkflowApiApiSessionWorkflowStartNewSessionPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SessionWorkflowApiApiSessionWorkflowStartNewSessionPost(requestParameters: SessionWorkflowApiApiSessionWorkflowStartNewSessionPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SessionWorkflowApiApiSessionWorkflowStartNewSessionPostAxiosParamCreator(requestParameters.xPlayerID, options, configuration);
    const request: () => AxiosPromise<StartNewSessionResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
